
import {DHXApp} from "dhx-optimus";

import {DHXView} from "dhx-optimus";



//-----

export class FindView extends DHXView{
	/*
	constructor(config){
		super(config);
		
		var self = this;
		
		self.dbDB = self.getService("dbDB");

		self.mypool = new poolstore.pool(10);
		
		self.current_index = 0;	
	
	}
	*/
//export class OfficeMainView extends DHXView{
	render(){
		var self = this;

		self.webAPI = self.getService("webAPI");

		self.root.attachEvent("onResizeFinish", function(win){
			// your code here
			self.onresize();
		});
		self.root.attachEvent("onBeforeMoveStart", function(win){
			// your code here
			
			return true; // allow window moving to be started
		});	
		
		//-----
		
		self.setupLayout();
		
		self.setupCarousel();
		
		self.GetAddresses();
	}
	
	setupLayout() {
		var self = this;
		
		//console.log("config: setupLayout");
	
		self.ui = self.root.attachLayout("5I");
		self.ui.setOffsets({
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		});
		//self.ui.setAutoSize("a;b;d;e", "b;c;d");
 	
		//self.ui.cells("c").conf.size.h = 700;
		self.ui.cells("c").setWidth(400);
		self.ui.cells("c").setHeight(900);

		self.ui.setAutoSize("a;b;d;e", "a;e");
		
		self.ui.setSizes();
		
		self.ui.forEachItem( cell =>{
			cell.hideHeader();
			cell.fixSize(true, true);
		});
		self.ui.setSeparatorSize(0, 0);
		self.ui.setSeparatorSize(1, 0);
		self.ui.setSeparatorSize(2, 0);
		self.ui.setSeparatorSize(3, 0);
	}
	
	setupCarousel() {
		var self = this;
		
		self.carousel = self.ui.cells("c").attachCarousel();	
	}
	
	sendCommand( baseURL, command, callback ) {
		
		$.ajax({
			type: "GET",
			url: baseURL + "Command/" + command,
			data: "",//JSON.stringify(element),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (data, status) {

				//console.log("printers: " + data);
				
				if (callback != null) {			
					callback(data);
				}
				
			},
			error: function (request, status, error) {
				console.log("error in sendCommand: " + request.responseText);
			}
		});
	};

	GetAddresses() {
		var self = this;
		
		self.sendCommand("http://waterhero/api/", "GetAddresses", function(data) {
			console.log("GetAddresses: ");
			
			console.log("data: " + JSON.stringify(data));
			
			self.carousel.forEachCell(function(item){
				//console.log(item.getId());
				item.remove();
			});
			
			var i = 0, length = data.IPAddresses.length;
			for (i = 0; i < length; i++) {
				
				var address = data.IPAddresses[i];
				
				self.load_info(i, address);
			}		
		});	
		
	}
	
	load_info(index, address) {
		var self = this;
		
		console.log("address: " + address);
		
		self.sendCommand("http://" + address + "/api/", "GetInfo", function(infodata) {
			console.log("GetInfo: ");
			
			console.log("infodata: " + JSON.stringify(infodata));
			
			self.add_cell(index, infodata);
		});
	}
			
	add_cell(index, infodata) {
		var self = this;
		
		console.log("index: " + index);
		console.log("infodata.Modellname: " + infodata.Modellname);
		console.log("infodata.IPAddress: " + infodata.IPAddress);
		
		self.carousel.addCell(index, index);
		var cell = self.carousel.cells(index);
		
		var form = cell.attachForm(self.getCarouselForm());
		var container = form.getContainer("container");
		var address = infodata.IPAddress;
		
		form.attachEvent("onButtonClick", function(name){
			// your code here
			
			console.log("onButtonClick: " + name);
			console.log("IPAddress: " + address);
			
			document.location.replace("http://" + address + "/");			
		});
		
		
		//"assets/waterhero_logo_design_2_x_754.png"
		var newDiv = document.createElement("img");
		newDiv.src = "assets/waterhero_logo_design_2_x_754.png";
		newDiv.height=240;
		newDiv.width=200;
		container.appendChild(newDiv);
		 
		form.setItemValue("Modellname", infodata.Modellname);
		form.setItemValue("IPAddress", infodata.IPAddress);				
	}
	
	getnumber(number) {
		if(number <= 9)
		{ 
			return "0" + number;
		}
		return number;
	}
	
	getCarouselForm() {
		var formData = [
			{type: "settings", position: "label-right",inputWidth:80,},
			{type: "block", width: 300, list:[
				{type: "label", offsetLeft: 140, label: "WaterHero"},
				
				{type:"settings",position:"label-left",labelWidth:120,inputWidth:120, labelAlign:"right"},			

				{
					type:"container", 
					name:"container", 
					label:"", 
					offsetLeft: 75, 
					inputWidth:200, 
					inputHeight:240
				},
				/*
				{
					type: "image",      
					name: "image", 
					url:  "assets/waterhero_logo_design_2_x_754.png",
					imageWidth: 252, 
					imageHeight: 252,
					inputWidth: 260,
					inputHeight: 260,
					disabled: true,
				},
				*/
				{type: "block", width: 300, list:[
					{type: "button", name: "Verbinden", offsetLeft: 103, value: "Verbinden"},
				]},

				{type: "block", label: "Wifi", width: 300, list:[
					{type: "input", name:"Modellname", label: "Modellname:", value: "", labelAlign: "left"},
					{type: "input", name:"IPAddress", label: "IP-Address:", value: "", labelAlign: "left"},
				]},
				
			]}
		];
		return formData;
	}
	
	destroy() {
		var self = this;
		
		//console.log("officeview.destroy");
		
		//self.root.cell.removeChild(self.div_ribbon);
		
		super.destroy();
	}


	
	onresize() {
		var self = this;
		
		//console.log("onresize");
		
		var cell = self.root.cell;
		
		//self.divObj.style.left = cell.style.left;
		self.divObj.style.width = cell.style.width;
		
		self.mydhtmlx.setSizes();

		self.ribbon.getRibbon().setSizes();
	}
	
}


// WEBPACK FOOTER //
// ./sources/views/water/find.js